<template>
  <div :class="$style.container">
    <div class="vx-row mb-4" v-for="user in users" :key="`${user.id}`">
      <div class="vx-col w-full flex justify-center mx-auto">
        <vs-button type="border" class="w-full" @click="onSelectUser(user)">{{ user.name }}</vs-button>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full mb-4 flex justify-center mx-auto">
        <vs-button
          type="border"
          class="w-full"
          icon-pack="feather"
          icon="icon-plus"
          color="success"
          @click="onAddUser"
        >
          Добавить нового
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import modal from "../../../mixins/modalContext";

export default {
  name:    "UserSelectPopup",
  props:   ['users', 'showPartApart', 'onSelect', 'onAdd'],
  mixins:  [modal],
  methods: {
    onSelectUser( user ) {
      this.onSelect(user);
    },
    onAddUser() {
      this.onAdd();
    },
  },
};
</script>

<style module>
.container {
  max-width: 370px;
  margin: 0 auto;
}
</style>
